import httpClient from '@/api/http-client';

const endpoint = 'api/training-results';

const trainingResultService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  create: (trainingResult) => httpClient.post(`${endpoint}`, trainingResult),

  update: (trainingResult) => httpClient.put(`${endpoint}/${trainingResult.id}`, trainingResult),

  delete: (trainingResult) => httpClient.delete(`${endpoint}/${trainingResult.id}`),

  getDrivingTrainingResults: (payload) =>
    httpClient.get(`${endpoint}-for-driving-permits/${payload.user_id}/${payload.airport_id}`),

  getPermanentPersonTrainingResults: (user) =>
    httpClient.get(`api/ending-trainings-for-permanent-person-permits/${user.id}`),
};

export default trainingResultService;
